var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMusic = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 13,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 0.903,
  d: "M2.655 9.028a4.5 4.5 0 0 1 3.364-1.504c1.337 0 2.538.58 3.365 1.504m-6.73 0a4.5 4.5 0 0 0 3.365 1.505 4.5 4.5 0 0 0 3.365-1.505m-6.73 0a4.514 4.514 0 1 1 6.729 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m4.658 4.28.674-.336a.26.26 0 0 0 .117-.117l.336-.673a.261.261 0 0 1 .467 0l.337.673c.025.05.066.092.117.117l.673.337a.261.261 0 0 1 0 .467l-.673.336a.26.26 0 0 0-.117.117l-.337.673a.261.261 0 0 1-.467 0l-.336-.673a.26.26 0 0 0-.117-.117l-.674-.336a.261.261 0 0 1 0-.467"
})));
export default SvgMusic;